export const STATUSES = {
  APPROVED: "approved",
  REJECTED: "rejected",
  NEW: "new",
  ALL: "all",
};
